import Vue from 'vue';
import router from '../../config/routes'

const user = {
    state: {
        token: localStorage.getItem('token'),
        userId: localStorage.getItem('userId'),
        username: localStorage.getItem('userName'),
        avatar: localStorage.getItem('avatar'),
        type: localStorage.getItem('type'),
        accountType: localStorage.getItem('accountType'),
        account: localStorage.getItem('account'),
        roles: [],
        schoolId: localStorage.getItem('schoolId'),
        isLogout: false,
    },

    mutations: {
        SET_TOKEN: (state, token) => {
            state.token = token;
        },
        SET_UERID: (state, userId) => {
            state.userId = userId;
        },
        SET_USERNAME: (state, username) => {
            state.username = username;
        },
        SET_AVATAR: (state, avatar) => {
            state.avatar = avatar;
        },
        SET_TYPE: (state, type) => {
            state.type = type;
        },
        SET_ACCOUNTTYPE: (state, accountType) => {
            state.accountType = accountType;
        },
        SET_ACCOUNT: (state, account) => {
            state.account = account;
        },
        SET_ROLES: (state, roles) => {
            state.roles = roles;
        },
        SET_SCHOOLID: (state, schoolId) => {
            state.schoolId = schoolId;
        },
        SET_ISLOGOUT: (state, bool) => {
            state.isLogout = bool;
        }
    },

    actions: {
        // 获取用户信息
        GetInfo({state}){
            let params = {account_id: state.userId};
            return new Promise((resolve, reject) => {
                Vue.prototype.$api.post(Vue.prototype.$apiUrl.userInfo,params,(res)=>{
                    resolve(res);
                })
            });
        },
        // 退出
        LogOut({commit,state}) {
            let params = {
                account_id: state.userId,
                account_type: state.accountType
           }
            Vue.prototype.$api.post(Vue.prototype.$apiUrl.logout,params,()=>{
                localStorage.clear();
                commit('SET_TOKEN', '');
                commit('SET_UERID', '');
                commit('SET_USERNAME', '');
                commit('SET_TYPE', '');
                commit('SET_ACCOUNTTYPE', '');
                commit('SET_SCHOOLID', '');

                router.push({path: '/passport/login'});
                //location.reload();  // 为了重新实例化vue-router对象 避免bug
            })
        }
    }
};

export default user;



// WEBPACK FOOTER //
// ./vue/store/modules/user.js